export default {
  getConfig: state => {
    let data = localStorage.getItem('CONFIG_PAYLOAD');
    return JSON.parse(data);
  },
  getLookups: state => {
    let data = localStorage.getItem('LOOKUPS_PAYLOAD');
    return JSON.parse(data);
  },
  getConfigImagePath: state => {
    let data = localStorage.getItem('CONFIG_PAYLOAD');
    data = JSON.parse(data);
    if (!data) return '';
    return data.attachmentBaseUrl;
  },
};
